import BookingForm from '../components/BookingForm'

function Reservation() {
  return (
    <section>
      <BookingForm stylesForm='full-white' />
    </section>
  )
}

export default Reservation
